var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getLocaleConfig } from './getLocaleConfig';
import { formatDateTimeIntl } from './helpers/formatDateTimeIntl';
import { DateTimeParts } from './types';
var isSupportedDateTimePart = function (datePart) {
    return datePart in DateTimeParts;
};
export var dateToMessageFormat = function (resourceStringValue) { return function (value, locale) {
    var localeConfig = getLocaleConfig(locale);
    var formatDateTimeForLocale = formatDateTimeIntl(localeConfig.name);
    var variablePattern = /%\{(.*?)\}/gu;
    return resourceStringValue.replace(variablePattern, function (dateTimePartMatch, dateTimePart) {
        if (!isSupportedDateTimePart(dateTimePart)) {
            return dateTimePartMatch;
        }
        var dateTimePartConfig = localeConfig.options[dateTimePart];
        var formattedValue = formatDateTimeForLocale(__assign({}, dateTimePartConfig.options)).format(value);
        if (dateTimePartConfig.transforms && dateTimePartConfig.transforms.length > 0) {
            formattedValue = dateTimePartConfig.transforms.reduce(function (v, f) { return f(v, value); }, formattedValue);
        }
        return formattedValue;
    });
}; };
//# sourceMappingURL=dateToMessageFormat.js.map